import { BookingPaymentHistoryLogStatus } from "@/redux/slices/booking/types";

interface PaymentHistoryStatusProps {
  status: BookingPaymentHistoryLogStatus;
}

export const PaymentHistoryStatus = ({ status }: PaymentHistoryStatusProps) => {
  switch (status) {
    case "successful":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-success"></i> Success
        </span>
      );
    case "processing":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-info"></i> Processing
        </span>
      );
    case "pending":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-warning"></i> Pending
        </span>
      );
    case "failed":
    case "error":
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-danger"></i> Error
        </span>
      );
    default:
      return (
        <span className="flex items-center gap-2">
          <i className="inline-block h-[8px] w-[8px] shrink-0 rounded-full bg-danger"></i>
          <span className="capitalize">{status}</span>
        </span>
      );
  }
};
